export interface NHLTeam {
  abbreviation: string
  fullName: string
  city: string
}

export const NHL_TEAMS: Record<string, NHLTeam> = {
  ANA: { abbreviation: 'ANA', fullName: 'Anaheim Ducks', city: 'Anaheim' },
  BOS: { abbreviation: 'BOS', fullName: 'Boston Bruins', city: 'Boston' },
  BUF: { abbreviation: 'BUF', fullName: 'Buffalo Sabres', city: 'Buffalo' },
  CAR: { abbreviation: 'CAR', fullName: 'Carolina Hurricanes', city: 'Carolina' },
  CBJ: { abbreviation: 'CBJ', fullName: 'Columbus Blue Jackets', city: 'Columbus' },
  CGY: { abbreviation: 'CGY', fullName: 'Calgary Flames', city: 'Calgary' },
  CHI: { abbreviation: 'CHI', fullName: 'Chicago Blackhawks', city: 'Chicago' },
  COL: { abbreviation: 'COL', fullName: 'Colorado Avalanche', city: 'Colorado' },
  DAL: { abbreviation: 'DAL', fullName: 'Dallas Stars', city: 'Dallas' },
  DET: { abbreviation: 'DET', fullName: 'Detroit Red Wings', city: 'Detroit' },
  EDM: { abbreviation: 'EDM', fullName: 'Edmonton Oilers', city: 'Edmonton' },
  FLA: { abbreviation: 'FLA', fullName: 'Florida Panthers', city: 'Florida' },
  LAK: { abbreviation: 'LAK', fullName: 'Los Angeles Kings', city: 'Los Angeles' },
  MIN: { abbreviation: 'MIN', fullName: 'Minnesota Wild', city: 'Minnesota' },
  MTL: { abbreviation: 'MTL', fullName: 'Montreal Canadiens', city: 'Montreal' },
  NJD: { abbreviation: 'NJD', fullName: 'New Jersey Devils', city: 'New Jersey' },
  NSH: { abbreviation: 'NSH', fullName: 'Nashville Predators', city: 'Nashville' },
  NYI: { abbreviation: 'NYI', fullName: 'New York Islanders', city: 'New York' },
  NYR: { abbreviation: 'NYR', fullName: 'New York Rangers', city: 'New York' },
  OTT: { abbreviation: 'OTT', fullName: 'Ottawa Senators', city: 'Ottawa' },
  PHI: { abbreviation: 'PHI', fullName: 'Philadelphia Flyers', city: 'Philadelphia' },
  PIT: { abbreviation: 'PIT', fullName: 'Pittsburgh Penguins', city: 'Pittsburgh' },
  SEA: { abbreviation: 'SEA', fullName: 'Seattle Kraken', city: 'Seattle' },
  SJS: { abbreviation: 'SJS', fullName: 'San Jose Sharks', city: 'San Jose' },
  STL: { abbreviation: 'STL', fullName: 'St. Louis Blues', city: 'St. Louis' },
  TBL: { abbreviation: 'TBL', fullName: 'Tampa Bay Lightning', city: 'Tampa Bay' },
  TOR: { abbreviation: 'TOR', fullName: 'Toronto Maple Leafs', city: 'Toronto' },
  UTA: { abbreviation: 'UTA', fullName: 'Utah Hockey Club', city: 'Utah' },
  VAN: { abbreviation: 'VAN', fullName: 'Vancouver Canucks', city: 'Vancouver' },
  VGK: { abbreviation: 'VGK', fullName: 'Vegas Golden Knights', city: 'Vegas' },
  WPG: { abbreviation: 'WPG', fullName: 'Winnipeg Jets', city: 'Winnipeg' },
  WSH: { abbreviation: 'WSH', fullName: 'Washington Capitals', city: 'Washington' }
}

export const useNHLTeams = () => {
  const getTeamInfo = (abbreviation: string): NHLTeam | null => {
    return NHL_TEAMS[abbreviation.toUpperCase()] || null
  }

  const getTeamFullName = (abbreviation: string): string => {
    const team = getTeamInfo(abbreviation)
    return team?.fullName || abbreviation
  }

  return {
    NHL_TEAMS,
    getTeamInfo,
    getTeamFullName
  }
}